export default __webpack_public_path__ + "static/media/ic_guam.48b13601.svg";